import { toast } from "react-toastify";
import { VERIFY_TEST } from "../config/apiEndPoint";
import { GET, POST, DEL } from "config/api.config";

export const getVerifyTestMetadata = async () => {
  try {
    const response = await GET(VERIFY_TEST.GET_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitVerifyTestFilterData = async (data = {}) => {
  try {
    const response = await POST(VERIFY_TEST.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

const safeId = (id) => encodeURIComponent(String(id ?? "").trim());

const isMissingId = (id) => String(id ?? "").trim() === "";

export const approveVerifyTest = async (id = "") => {
  if (isMissingId(id)) {
    toast.error("Record ID not found");
    return;
  }
  try {
    const response = await POST(VERIFY_TEST.APPROVE(safeId(id)), {});
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const cancelVerifyTest = async (id = "") => {
  if (isMissingId(id)) {
    toast.error("Record ID not found");
    return;
  }
  try {
    const response = await DEL(VERIFY_TEST.CANCEL(safeId(id)), {});
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
